// extracted by css-extract-rspack-plugin
export default {"attachmentCellRoot":"AttachmentsCell_attachmentCellRoot__vmtgg"};